import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open(event) {
    event.preventDefault()

    const url = this.element.href

    window.open(url, "_blank", "toolbar=no,location=no,menubar=no,width=700,height=1000")
  }
}
